<button
  type="button"
  (click)="decrement()"
  [disabled]="control.disabled || control.value <= min"
  tabindex="-1"
>
  -
</button>

<input
  #qty
  type="number"
  [min]="min"
  [max]="max"
  [step]="step"
  [readonly]="readonly"
  [tabindex]="readonly ? -1 : 0"
  [formControl]="control"
  (change) = "valueChange($event)"
/>

<button
  type="button"
  (click)="increment()"
  [disabled]="control.disabled || control.value >= max"
  tabindex="-1"
>
  +
</button>
